import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { CommercialCompetenceService } from '../../services/commercial-competence.service';
import { FlashMessagesService } from 'angular2-flash-messages';

@Component({
  selector: 'app-cc-culture',
  templateUrl: './cc-culture.component.html',
  styleUrls: ['./cc-culture.component.scss']
})
export class CcCultureComponent implements OnInit {


  @Input("canEdit") canEdit;

 // commercialCompetenceService.proposalCultures
  private cultureList;
  private UFList;
  private cityList;

  private selectedUFIndex;
  private selectedCultureIndex;
  private selectedCityIndex;
  private ownArea;
  private rentArea;


  
  constructor(private commercialCompetenceService: CommercialCompetenceService,
              private flashMessagesService: FlashMessagesService) { }

  ngOnInit() {
    this.getCultureList();
    this.getStates();
  }

  addCulture(){

    console.log("CULTURAID", this.selectedCultureIndex);
    console.log("EstadoID", this.selectedUFIndex);
    console.log("CidadeID", this.selectedCityIndex);

    this.commercialCompetenceService.proposalCultures.push({
      CulturaID: this.cultureList[this.selectedCultureIndex].ID,
      CulturaNome: this.cultureList[this.selectedCultureIndex].Descricao,
      EstadoID: this.UFList[this.selectedUFIndex].ID,
      EstadoNome: this.UFList[this.selectedUFIndex].Nome,
      CidadeID: this.cityList[this.selectedCityIndex].ID,
      CidadeNome: this.cityList[this.selectedCityIndex].Nome,
      AreaPropria: this.ownArea,
      AreaArrendada: this.rentArea ? this.rentArea : 0
    });
    
    this.selectedCultureIndex = null;
    this.selectedUFIndex = null;
    this.selectedCityIndex = null;
    this.ownArea = null;
    this.rentArea = null;
  }

  removeCulture(index){
    this.commercialCompetenceService.proposalCultures.splice(index, 1);
  }

  changeSelectedUF(){
    this.getCitiesByUF(this.UFList[this.selectedUFIndex].ID);
  }

  getCitiesByUF(ufId){
    this.commercialCompetenceService.getCitiesByState(ufId).subscribe(result => {
      if (result.Success) {
        this.cityList = result.Result;
        console.log("cityList",this.cityList);
      } else {
        this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
      }
    }, error => {
      console.log(error);
    });
  }

  getCultureList(){
    this.commercialCompetenceService.getCultureList().subscribe(result => {
      if (result.Success) {
        this.cultureList = result.Result;
        console.log("cultureList",this.cultureList);
      } else {
        this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
      }
    }, error => {
      console.log(error);
    });
  }

  showCultureDescription(cultureID){
    const culture = this.cultureList.filter(culture => culture.ID == cultureID);
    return culture[0].Descricao;
  }

  getStates(){
    this.commercialCompetenceService.getStates().subscribe(result => {
      if (result.Success) {
        this.UFList = result.Result;
        console.log("UF List",this.UFList);
      } else {
        this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
      }
    }, error => {
      console.log(error);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/commercial-competence/commercial-competence/cc-culture/cc-culture.component.ts